module.exports = __webpack_public_path__ + "static/media/4.9263abc2.JPG";